import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { fetchSectionSkills, getCurrentUserId } from '../../SkillsApi/SkillsApi'
import './AiCoursePage.css'
import AiModuleOne from "./AicourseImage/ai_1.png"
import AiModuleTwo from "./AicourseImage/ai_2.png"
// import AiModuleThree from "./AiCourseImage/aiModuleThree.webp"
// import AiModuleFour from "./AiCourseImage/aiModuleFour.webp"
// import AiModuleFive from "./AiCourseImage/aiModuleFive.webp"

const SECTION = 'AiSection'

const AI_COURSE_ITEMS = [
  {
    id: 1,
    imageUrl: AiModuleOne,
    title: 'Module 1: Getting Started',
    description: 'Kickstart your journey with the fundamentals of AI before diving deeper.',
    route: '/ai_module_intro',
  },
  {
    id: 2,
    imageUrl: AiModuleTwo,
    title: 'Module 2: Core Concepts',
    description: 'Build on the basics and understand the core ideas that drive AI systems.',
    route: '/ai_module_core_two',
  },
  {
    id: 3,
    // imageUrl: AiModuleThree,
    title: 'Module 3: Deep Dive',
    description: 'Go beyond the surface with a detailed, hands-on exploration of the topic.',
    // route: '/ai_module_one_intro_three',
  },
  {
    id: 4,
    // imageUrl: AiModuleFour,
    title: 'Module 4: Applied Practice',
    description: 'Apply what you have learned through real, practical AI scenarios.',
    // route: '/ai_module_one_intro_four',
  },
  {
    id: 5,
    // imageUrl: AiModuleFive,
    title: 'Module 5: Final Wrap-up',
    description: 'Bring everything together and complete your AI learning path.',
    // route: '/ai_module_one_intro_five',
  },
]

const AiCoursePage = () => {
  const navigate = useNavigate()
  const [moduleProgress, setModuleProgress] = useState({})
  const [loading, setLoading] = useState(true)

  // Re-fetches progress from MongoDB every time the page mounts, so
  // coming back from a just-finished module instantly reflects the
  // newly unlocked card — no stale local cache involved.
  useEffect(() => {
    const userId = getCurrentUserId()

    if (!userId) {
      setLoading(false)
      return
    }

    fetchSectionSkills(userId, SECTION)
      .then((data) => {
        setModuleProgress(data && typeof data === 'object' ? data : {})
        setLoading(false)
      })
      .catch((err) => {
        console.error('fetchSectionSkills failed:', err)
        setModuleProgress({})
        setLoading(false)
      })
  }, [])

  const getPercentFor = (id) => moduleProgress?.[`module${id}`]?.percent ?? 0

  const isCompleted = (id) => getPercentFor(id) >= 100

  const isUnlocked = (id) => id === 1 || isCompleted(id - 1)

  const goToModule = (route) => {
    navigate(route)
  }

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      document.querySelector("#root")?.scrollIntoView({ behavior: "smooth" })
    })
    return () => cancelAnimationFrame(id)
  }, [])

  return (
<>


    <section className="ai_course_pg_wrapper">
      <div className="ai_course_pg_header">
        <br/>
        <br/>
        <h2 className="ai_course_pg_heading">Your AI Learning Path</h2>
        <p className="ai_course_pg_subheading">
          Complete each module in order to unlock the next one.
        </p>
      </div>

      {loading ? (
        <p className="ai_course_pg_loading">Loading your course...</p>
      ) : (
        <div className="ai_course_pg_grid">
          {AI_COURSE_ITEMS.map((item, index) => {
            const unlocked = isUnlocked(item.id)
            const isDone = isCompleted(item.id)
            const isAboveFold = index === 0

            return (
              <div
                key={item.id}
                className={`ai_course_pg_card ${unlocked ? '' : 'ai_course_pg_card_locked'}`}
              >
                <div className="ai_course_pg_card_inner">
                  <div className="ai_course_pg_image_wrap">
                    <img
                      src={item.imageUrl}
                      alt={`upskld ${item.title}`}
                      className="ai_course_pg_image"
                      width="400"
                      height="240"
                      loading={isAboveFold ? "eager" : "lazy"}
                      decoding="async"
                      fetchpriority={isAboveFold ? "high" : "low"}
                    />
                    {isDone && (
                      <span className="ai_course_pg_done_badge">
                        &#10003; Completed
                      </span>
                    )}
                  </div>

                  <h3 className="ai_course_pg_card_title">{item.title}</h3>
                  <p className="ai_course_pg_card_desc">{item.description}</p>

                  {unlocked && (
                    <button
                      type="button"
                      className="ai_course_pg_watch_btn"
                      onClick={() => goToModule(item.route)}
                    >
                      Watch Video
                    </button>
                  )}
                </div>

                {!unlocked && (
                  <div className="ai_course_pg_lock_overlay">
                    <span className="ai_course_pg_lock_icon">&#128274;</span>
                    <span className="ai_course_pg_upcoming_badge">UPCOMING</span>
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
    </section></>
  )
}

export default AiCoursePage
